export default function Node() {
    return (
        <div className='node'></div>
    )
}